export function prepareClasses(classes, attracted, reqIds) {
  const classifiers_classes_ids = classes.reduce((acc, item) => {
    if (item.with_children) {
      return [...acc, item.id, ...item.children_list];
    } else {
      return [...acc, item.id];
    }
  }, []);

  const auto_selection_ids = attracted.reduce((acc, item) => {
    if (item.selected && !classifiers_classes_ids.includes(item.id)) {
      classifiers_classes_ids.push(item.id);
      return [...acc, item.id];
    } else {
      return acc;
    }
  }, []);

  return {
    requirements_ids: reqIds,
    classifiers_classes_ids,
    auto_selection_ids,
    characteristic_classes: {},
  };
}

export function checkIsType(code, section) {
  let lastSymbol = Number(code.at(-1));

  return !Number.isNaN(lastSymbol) && section !== 'Prp';
}
